import { Reducer } from 'react';
import { RequestSummary } from '../../bravoTypes';
import { RequestAction } from '../actions/request';

export type RequestState = {
    request?:RequestSummary;
};

const requestReducer:Reducer<RequestState, RequestAction> = (state = {}, action) => {
    switch(action.type){
        case "request.set":
            return {
                ...state,
                request:action.payload
            };
        default:
            return state;
    }
}

export default requestReducer;